import AppCatalog from "@/services/App/AppCatalog.js";
import AppModule from "@/services/App/AppModule.js";
import InputType from "@/services/Input/InputType.js";
import OutputType from "@/services/Input/OutputType.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Date: {
    Label: "Tanggal",
    Type: InputType.Date,
    Required: true,
    RequiredHide: true,
  },
  SONumber: {
    Label: "Nomor Penjualan",
    Type: InputType.Text,
    MaxLength: 50,
    Highlight: true,
    ReadOnly: true
  },
  InvoiceDate: {
    Label: "Tanggal Penjualan",
    PrintLabel: "Tanggal Transaksi",
    Type: InputType.Date,
    ReadOnly: true
  },
  ClientID: {
    Label: AppModule.Client.FullName,
    ExportLabel: AppCatalog.Info.ID + " " + AppModule.Client.FullName,
    PrintLabel: "Nama " + AppModule.Client.FullName,
    Type: InputType.ID,
    Help: [
      "Pilih dari master Pelanggan, atau ketik manual.",
      "Pelanggan tersusun atas Alias dan Nama."
    ],
    ReadOnly: true,
    RelatedValue: "Client",
    RelatedModule: AppModule.Client
  },
  Client: {
    Label: "Pelanggan",
    Type: InputType.Text,
    MaxLength: 500,
    Required: true,
    Highlight: true,
    ReadOnly: true
  },
  PaymentTypeID: {
    Label: "Jenis Pembayaran",
    Type: InputType.ID,
    Input: InputType.Select,
    Required: true,
    RelatedValue: "PaymentTypeName",
    RelatedModule: AppModule.PaymentType,
  },
  PaymentTypeName: {
    Label: "Jenis Pembayaran",
    Type: InputType.Text,
    ReadOnly: true
  },
  PaymentValue: {
    Label: "Jumlah Bayar",
    Type: InputType.Decimal,
    ReadOnly: true,
    Output: OutputType.Decimal.Accounting
  },
  Total: {
    Label: "Total",
    Type: InputType.Integer,
    ReadOnly: true,
    Output: OutputType.Integer.Currency
  },
}